/*
 * @Description: 门店首页
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import viewName from '../constant.js'
import {
    getStoreHomeInfo
} from '@/models/storeHome'
import DiscountServiceItem from '@/components/discountServiceItem/discountServiceItem'
import DistributionGoodsItem from '@/components/distributionGoodsItem/distributionGoodsItem'
import GuideFloating from '@/components/guideFloating/guideFloating'
import InfiniteLoading from 'vue-infinite-loading'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import { wxSharebyData } from '@/utils/wxsdk'
import StoreInfo from './components/storeInfo'
import SectionTitle from '@/components/sectionTitle/sectionTitle'

export default {
    inject: ['showLoading', 'hideLoading'],
    name: viewName.storeHome,
    components: {
        StoreInfo,
        SectionTitle,
        DiscountServiceItem,
        DistributionGoodsItem,
        InfiniteLoading,
        GuideFloating,
        appGuideDialog
    },
    data () {
        return {
            reqSuccess: false,
            position:{
                lng: '',
                lat: ''
            },
            services : [], // 特惠服务列表
            goods: [], // 精选商品
            distribution_user_type: '', // 分销员类型
            store_info: {
                store_name: '', // 门店名称
                store_address: '', // 门店地址
                store_id: '', // 门店id
                'lng': '113.33273900000', // 经度
                'lat': '23.20304900000', // 维度
                'distance': 500, // 距离（米）
                'mobile': '19121212121', // 联系电话
            },
            detailParams:{
                distribution_code:'',
                distribution_store_type:'',
                store_id:''
            },
            share: {
                desc: '',
                imgUrl: '',
                title: ''
            },
            /* 浮动按钮 */
            floatBtn:[
                {
                    key: 'join_distribution',
                    top: '70',
                },
                {
                    key: 'app_download',
                    top: '78',
                }
            ]
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
        ...mapGetters([
            'wxUserInfo'
        ]),
    },
    created () {
        this.detailParams = this.$route.query
    },
    activated () {

    },
    mounted () {
        document.documentElement.scrollTop = document.body.scrollTop = 0
        this.$emit('setHeader', {
            title: '门店主页',
            showHeader: true,
            showLeft: true
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        this.getStoreInfo()
    },
    methods: {
        ...mapActions(['setAppClass', 'getWxUserInfo', 'getLocation']),
        /**
         * 获取本地地址
         */
        getMyLocation () {
            return this.getLocation({ timeout: 3000 }).then(this.getPosition)
        },
        /*
         * 获取位置信息并转换为百度坐标系
         */
        getPosition (position) {
            this.position = position
            console.log('获取到的坐标', this.position)
        },
        /**
         * 跳转特惠服务全部
         */
        onMoreDiscountService () {
            this.$router.push({
                name: 'discountService',
                query: {
                    distribution_code: this.detailParams.distribution_code,
                    from: 'store_home',
                    store_id: this.detailParams.store_id
                }
            })
        },
        /**
         * 更多商品
         */
        onMoreGoods () {
            this.$router.push({
                name: 'distributionList', // 分销商品列表
                query: {
                    distribution_code: this.detailParams.distribution_code,
                    store_id: this.detailParams.store_id
                }
            })
        },
        /**
         * 跳转特惠服务详情
         */
        onGoToDiscountServiceDetail (item) {
            this.$router.push({
                name: 'marketingActivities',
                query: {
                    distribution_code: this.detailParams.distribution_code,
                    sstore_id: item.store_id,
                    package_id: item.activity_id
                }
            })
        },
        /*
         * 跳转分销商品详情
         */
        onGoToDistributionGoodsDetail (item) {
            // 1： 平台分销员， 2：门店分销员， 3：平台&门店分销员
            const isOneStore = this.distribution_user_type === 2 || this.distribution_user_type === 3
            this.$router.push({
                name: 'distributionDetail', // 分销商品详情
                query: {
                    distribution_code: this.detailParams.distribution_code,
                    spu_id: item.spu_id,
                    goods_sstore_id: this.store_info.store_id,
                    sstore_id: this.store_info.store_id,
                    spec_id: item.spec_id,
                    distribution_user_type: this.distribution_user_type,
                    distribution_store_type: isOneStore ? '2' : '' // 2等于单店
                }
            })
        },
        /**
         * 配置微信分享
         */
        configWxShare () {
            if (this.isWeixin) {
                const imgUrl = this.store_info.store_img === '' ? 'https://image.carisok.com/images/logo.png' : this.store_info.store_img
                wxSharebyData({
                    // 分享朋友
                    appMesage: {
                        title: this.store_info.store_name,
                        desc: `更多想不到惊喜优惠在等你，快来看看吧！`,
                        imgUrl
                    },
                    // 分享朋友圈
                    timeline: {
                        title: `${this.store_info.store_name} #更多想不到惊喜优惠在等你，快来看看吧！`,
                        imgUrl
                    }
                })
            }
        },
        /**
         * 获取门店数据信息
         */
        async getStoreInfo () {
            this.reqSuccess = false
            this.showLoading()
            const {lat, lng} = this.position
            if (!lat && !lng) {
                await this.getMyLocation().catch((e) => {
                    console.log(e)
                })
            }
            try {
                const res = await getStoreHomeInfo({
                    store_id: this.detailParams.store_id,
                    distribution_code: this.detailParams.distribution_code,
                    lng: this.position.lng,
                    lat: this.position.lat
                })
                this.distribution_user_type = res.distribution_user_type // 1： 平台分销员， 2：门店分销员， 3：平台&门店分销员
                this.services = res.services
                this.store_info = res.store_info
                this.goods = res.goods.map((item) => {
                    return {
                        ...item,
                        sstore_id: this.detailParams.store_id,
                    }
                })
                this.reqSuccess = true
                /* 设置微信分享 */
                this.configWxShare()
            } catch (e) {
                console.log(e)
            }
            this.hideLoading()
        }
    }
}
